import axios from 'axios';
import cookie from 'vue-cookies';

// 相關的 api
const endpoint = axios.create({
  baseURL: 'https://codingwizard.tw/api/v1',
  // baseURL: `${window.location.protocol}//${window.location.host}/api/v1`,
});

export default function init(store) {
  const reqSucInterceptors = (conf) => {
    const cookieValue = cookie.get('CWLUser');

    let token;

    if (cookieValue) token = cookieValue.token;

    const noLoading = conf.url === '/chat'
      || ((conf.method === 'put' || conf.method === 'post')
      && (conf.url.includes('/chatroomread') || conf.url.includes('/chatread')));

    // eslint-disable-next-line no-param-reassign
    if (token) conf.headers.common.Authorization = `Bearer ${token}`;
    if (!noLoading) store.commit('common/START_LOADING');
    return conf;
  };

  const reqErrInterceptors = (err) => {
    store.commit('common/START_LOADING');
    return Promise.reject(err);
  };

  const resSucInterceptors = (res) => {
    store.commit('common/FINISH_LOADING');
    return res;
  };

  const resErrInterceptors = (err) => {
    if (err.response) {
      switch (err.response.status) {
        case 401:
          this.$cookies.remove('CWLUser');
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
          break;
        default:
      }
    }
    store.commit('common/FINISH_LOADING');
    return Promise.reject(err);
  };

  endpoint.interceptors.request.use(reqSucInterceptors, reqErrInterceptors);
  endpoint.interceptors.response.use(resSucInterceptors, resErrInterceptors);
}

export { endpoint };
